import React, {useEffect, useState} from 'react';
import {useQuery} from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;

const ImageCellRenderer = ({data}) => {
    const [imageUrl, setImageUrl] = useState("")
    const {id, image_id, file} = data;

    const { data: attachImage } = useQuery({
        queryKey: ['image', id, image_id, file],
        queryFn: async () => {
            if (file) return URL.createObjectURL(file)
            const imagePath = API_URL + (image_id ? `/attach/${image_id}` : "/corporation/entity/image")

            const res = await fetch(imagePath);
            return await res.blob();
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    useEffect(() => {
        if (file) {
            setImageUrl(URL.createObjectURL(file))
        } else if (attachImage) {
            setImageUrl(URL.createObjectURL(attachImage))
        }
    }, [file, attachImage]);

    return (
        <div className="mt-1 w-7.5 bg-white border rounded shadow-sm">
            { imageUrl && <img className={"w-full h-5 object-contain"} src={imageUrl} alt="" loading="lazy"/> }
        </div>
    );
};

export default ImageCellRenderer;